var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabellTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 76,
    viewBox: "0 0 80 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.660889 30.3721C0.660889 22.993 6.64286 17.011 14.022 17.011H66.4225C73.8017 17.011 79.7836 22.993 79.7836 30.3721V58.3946C79.7836 65.7737 73.8017 71.7557 66.4225 71.7557H14.022C6.64285 71.7557 0.660889 65.7737 0.660889 58.3946V30.3721ZM14.022 21.511C9.12814 21.511 5.16089 25.4782 5.16089 30.3721V58.3946C5.16089 63.2885 9.12814 67.2557 14.022 67.2557H66.4225C71.3164 67.2557 75.2836 63.2885 75.2836 58.3946V30.3721C75.2836 25.4782 71.3164 21.511 66.4225 21.511H14.022Z",
    fill: "#00A3A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3712 0.90608C58.2499 1.78476 58.2499 3.20938 57.3712 4.08806L40.7577 20.7015C39.8791 21.5802 38.4544 21.5802 37.5758 20.7015L26.5716 9.69733C25.6929 8.81865 25.6929 7.39403 26.5716 6.51535C27.4503 5.63667 28.8749 5.63667 29.7536 6.51535L39.1668 15.9285L54.1892 0.90608C55.0679 0.0274004 56.4925 0.0274004 57.3712 0.90608Z",
    fill: "#00A3A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1418 67.2559C12.3845 67.2559 13.3918 68.2632 13.3918 69.5059V73.5031C13.3918 74.7457 12.3845 75.7531 11.1418 75.7531C9.8992 75.7531 8.89185 74.7457 8.89185 73.5031V69.5059C8.89185 68.2632 9.8992 67.2559 11.1418 67.2559Z",
    fill: "#00A3A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3027 67.2559C70.5454 67.2559 71.5527 68.2632 71.5527 69.5059V73.5031C71.5527 74.7457 70.5454 75.7531 69.3027 75.7531C68.0601 75.7531 67.0527 74.7457 67.0527 73.5031V69.5059C67.0527 68.2632 68.0601 67.2559 69.3027 67.2559Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabellTv);
export default __webpack_public_path__ + "static/media/CabellTv.5939b7629946d65ea5f755cf969dbf4e.svg";
export { ForwardRef as ReactComponent };